import React from 'react';
import { useNavigate } from 'react-router-dom';
import type { CustomCellRendererProps } from 'ag-grid-react';

export const EventTitleRenderer = (props: CustomCellRendererProps) => {
  const navigate = useNavigate();
  const eventTitle = props.value;
  const eventHandle = props.data?.eventHandle;
  
  if (!eventTitle) {
    return null;
  }
  
  if (eventHandle) {
    return (
      <span 
        style={{ color: '#E35205', cursor: 'pointer', textDecoration: 'underline' }}
        onClick={(e) => {
          e.stopPropagation();
          navigate(`/e/${eventHandle}`);
        }}
      >
        {eventTitle}
      </span>
    );
  }
  
  return <span>{eventTitle}</span>;
};



